/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import { createReducer } from 'reduxsauce';
import { Types } from './action';

const INITIAL_STATE = {
  profileData: [],
  profileMeta: {},
  profileCount: null,
  //   usersUploadedData: [],
  searchQueries: {},
  //   valueForOutline: [],
  profilePermissions: {},
  loading: false,
  error: null
};

const getProfileListStart = (state = INITIAL_STATE, action) => ({
  ...state,
  loading: true
});
const getProfileListSuccess = (state = INITIAL_STATE, action) => {
  const { data, meta, Count, profilePermissions } = action.payload;
  return {
    ...state,
    profileData: data,
    profileMeta: meta,
    profileCount: Count,
    profilePermissions,
    loading: false
  };
};
const getProfileListFailure = (state = INITIAL_STATE, action) => {
  const { error } = action.payload;
  return {
    ...state,
    error,
    loading: false
  };
};

const setSearchQueries = (state = INITIAL_STATE, action) => ({
  ...state,
  searchQueries: { ...action.payload }
});

const HANDLERS = {
  [Types.GET_PROFILE_LIST_START]: getProfileListStart,
  [Types.GET_PROFILE_LIST_SUCCESS]: getProfileListSuccess,
  [Types.GET_PROFILE_LIST_FAILURE]: getProfileListFailure,

  [Types.SET_SEARCH_QUERIES]: setSearchQueries
};

export const ProfileReducer = createReducer(INITIAL_STATE, HANDLERS);
